import { AppBar, Fab, Grid, Paper, Tab, Tabs, Tooltip } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Modal from 'Components/Modal'
import User from 'EurestoClass/User'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import React, { useMemo, useState } from 'react'


export default props => {

    const [action, setAction] = useState(props.action === 'add' && props.isAllow && (props.isAllow.add && props.action || ' ') || props.action)
    const [modalDelete, setModalDelete] = useState(false)
    const [required, setRequired] = useState(false)

    const labelTab = _ =>
        action === 'view' && (
            <Grid container style={{
                margin: 0,
                display: 'block',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                ...(props.mainTabProps && props.mainTabProps.style || { padding: '0 10px' })
            }} spacing={0} justify={'center'} alignItems={'center'}
                alignContent={'center'} wrap={'nowrap'}>
                <i className={'ei-commun_visualiser'} style={{ fontSize: 18 }} />&nbsp;{props.libelle}
            </Grid>
        )
        || action === 'update' &&
        (
            <Grid container style={{
                margin: 0,
                display: 'block',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                ...(props.mainTabProps && props.mainTabProps.style || { padding: '0 10px' })
            }} spacing={0} justify={'center'} alignItems={'center'}
                alignContent={'center'} wrap={'nowrap'}>
                <i className={'ei-commun_modifier'} style={{ fontSize: 18 }} />&nbsp;{props.libelle}
            </Grid>
        )
        || action === 'add' &&
        (
            <Grid container style={{
                margin: 0,
                display: 'block',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                ...(props.mainTabProps && props.mainTabProps.style || { padding: '0 10px' })
            }} spacing={0} justify={'center'} alignItems={'center'}
                alignContent={'center'} wrap={'nowrap'}>
                <i className={'ei-commun_ajouter'}
                    style={{ fontSize: 18 }} />&nbsp;{props.libelleAdd || EurestoI18n.t('commun:Nouveau')}
            </Grid>
        )
        || 'Saisie valeur bloquée'

    const onUpdate = (e) => {
        setAction('update')
        props.onUpdate && props.onUpdate()
    }

    const onDuplicate = (e) => {
        setAction('add')
        props.onUpdate && props.onUpdate()
    }

    const onUnarchive = () => {
        props.onUnarchive && props.onUnarchive()
    }

    const onArchive = () => {
        setAction('archive')
        props.onArchive && props.onArchive()
    }

    const onCloseDeleteModal = (view) => _ => {
        setModalDelete(view)
    }

    const onSave = () => {
        console.log(props.required, props.object)
        if (props.required && Object.keys(props.required).length > 0 && props.object === undefined) {
            alert('Vous devez faire passer l\'objet du formulaire pour détecter les champs non renseignés')
            return;
        } else if (props.required && Object.keys(props.required).length > 0) {
            const requiredNotDefined = Object.keys(props.required).filter(required => props.object[required] === undefined)
            if (requiredNotDefined && requiredNotDefined.length > 0) {
                setRequired(requiredNotDefined.map(not => props.required[not]))
                return
            }
        }
        props.onSave(action)
    }

    const onAdd = () => {
        props.onCancel()
    }

    const onCancel = () => {
        props.onView(action)
    }

    let buttons = useMemo(() => {
        const btns = []
        if (action === 'view') {
            User.isAddUpdateDeleteAvaibleForMe() && props.isAllow && props.isAllow.add && btns.push({
                title: 'Ajouter',
                className: 'EurestoSecondary--text',
                icon: 'ei-commun_ajouter',
                cb: onAdd
            })
            User.isAddUpdateDeleteAvaibleForMe() && props.isAllow && props.isAllow.update && btns.push({
                title: 'Modifier',
                className: 'EurestoSecondary--text',
                icon: 'ei-commun_modifier',
                cb: onUpdate
            })
            User.isAddUpdateDeleteAvaibleForMe() && props.isAllow && props.isAllow.duplicate && btns.push({
                title: 'Dupliquer',
                className: 'EurestoSecondary--text',
                icon: 'ei-commun_dupliquer',
                cb: onDuplicate
            })
            User.isAddUpdateDeleteAvaibleForMe() && props.isAllow && props.isAllow.archive && btns.push({
                title: 'Archiver',
                className: 'EurestoError--text',
                icon: 'ei-commun_archiver',
                cb: onArchive
            })
            User.isAddUpdateDeleteAvaibleForMe() && props.isAllow && props.isAllow.delete && btns.push({
                title: 'Supprimer',
                className: 'EurestoError--text',
                icon: 'ei-commun_supprimer',
                cb: onCloseDeleteModal(true)
            })
            User.isAddUpdateDeleteAvaibleForMe() && props.isAllow && props.isAllow.unarchive && btns.push({
                title: 'Désarchiver',
                className: 'EurestoSecondary--text',
                icon: 'ei-commun_reouvrir',
                cb: onUnarchive
            })
        } else if (action === 'update' || action === 'add' || action === 'archive' && User.isAddUpdateDeleteAvaibleForMe()) {
            !props.isAllow || props.isAllow.cancel !== false && btns.push({
                title: 'Annuler',
                className: 'EurestoError--text',
                icon: 'ei-commun_fermer',
                cb: onCancel
            })
            btns.push({
                title: 'Enregistrer',
                className: 'EurestoSecondary--text',
                icon: 'ei-commun_valider',
                cb: onSave
            })
        }
        if (props.buttons) {
            btns.push(...(props.buttons || []).filter(button => button.isAllow))
        }
        console.log(props.buttons)
        return btns
    }, [action, props.buttons])

    return (
        <Grid container spacing={0} style={{
            position: 'relative',
            overflow: 'hidden',
            padding: 15,
            width: '100%',
            height: '100%',
            backgroundColor: '#F3F3F3'
        }}>
            <Grid container alignContent={'space-between'} justify={'center'} alignItems={'center'} wrap={'nowrap'}>
                <Grid item style={{ width: 351 }}>
                    <AppBar position='static' color='default'
                        style={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
                        <Tabs TabIndicatorProps={{ style: { backgroundColor: 'white' } }} value={0}
                            onChange={props.handleChange}
                            style={{ backgroundColor: 'transparent' }}>
                            <Tooltip disableTouchListener style={{ zIndex: 1 }} placement="bottom"
                                title={<div style={{ fontSize: 18, padding: 10 }}>{props.libelle}</div>}>
                                <div>
                                    <Tab value={0} disabled style={{
                                        opacity: 1,
                                        width: 351,
                                        fontSize: 15,
                                        borderTopLeftRadius: 5,
                                        borderTopRightRadius: 5,
                                        zIndex: 1,
                                        borderBottom: '.5px solid white'
                                    }} label={labelTab()} />
                                </div>
                            </Tooltip>
                        </Tabs>
                    </AppBar>
                </Grid>
                <Grid item style={{ width: 'calc(100% - 701px)' }}>
                    <AppBar position='static' color='default'
                        style={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
                        <Tabs TabIndicatorProps={{ style: { backgroundColor: 'white' } }} value={props.value}
                            onChange={props.handleChange} style={{ backgroundColor: 'transparent' }}
                            variant="scrollable">
                            {
                                props.tabs.map(tab => tab.allow !== false &&
                                    <Tab key={'secondaryTabs-' + tab.value}
                                        disabled={props.disabled && props.value !== tab.value}
                                        value={tab.value} label={tab.label} style={{
                                            borderTopLeftRadius: 5,
                                            borderTopRightRadius: 5,
                                            zIndex: 1,
                                            borderBottom: '.5px solid white',
                                            backgroundColor: tab.backgroundColor,
                                            color: tab.color
                                        }} />)
                            }
                        </Tabs>
                    </AppBar>
                </Grid>
                <Grid item style={{ width: 360 }}>
                    <Grid container justify={'flex-end'} alignContent={'center'} alignItems={'center'}>
                        {
                            buttons.map((b, i) => {
                                return b.title &&
                                    <Button key={i}
                                        size={'small'}
                                        variant={'contained'}
                                        style={{
                                            ...(i > 0 && { marginLeft: 5 } || {}),
                                            border: '1px solid ' + EurestoColor('EurestoPrimary'),
                                            ...(b.style || {}),
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            b.cb()
                                        }}
                                        disabled={b.disabled || false}
                                        className={(b.disabled ? 'EurestoDisabled' : 'EurestoText--text ' + (b.className && b.className.replace('--text', '') || 'EurestoPrimary'))}>
                                        <Grid container justify={'center'} alignContent={'center'}
                                            alignItems={'center'}>&nbsp;<i
                                                className={b.icon + ' ' + (b.disabled ? '' : 'EurestoText--text')} />&nbsp;{b.title}&nbsp;
                                        </Grid></Button>
                                    ||
                                    <Fab key={i} style={Object.assign(i > 0 && {
                                        marginLeft: 5,
                                        //fontSize: 15
                                    } || {}, b.style || {})} size="small" onClick={(e) => {
                                        e.stopPropagation()
                                        b.cb()
                                    }}
                                        disabled={b.disabled || false}
                                        className={(b.disabled ? 'EurestoDisabled' : ('EurestoPrimary ' + b.className))}>
                                        <i
                                            className={'fa fa-' + b.icon + ' ' + (b.disabled ? '' : 'EurestoText--text')} />
                                        <span className={(b.disabled ? '' : 'EurestoText--text')} />
                                    </Fab>
                            })
                        }
                    </Grid>
                </Grid>
            </Grid>
            <Paper style={{
                width: 'calc(100% - 2px)',
                marginLeft: 1,
                height: User.CalculHeight.getHeightWanted(61),
                maxHeight: User.CalculHeight.getHeightWanted(61),
                position: 'relative',
                borderTopLeftRadius: 0,
            }}>
                <Grid container spacing={0}
                    style={{
                        width: '100%',
                        margin: 0,
                        padding: 0,
                        maxHeight: "100%",
                        height: '100%',
                        position: 'relative'
                        //paddingTop: 10,
                    }}>
                        <Grid item style={{
                            margin: 0,
                            padding: 0,
                            position: 'relative',
                            width: 350,
                            minWidth: 350,
                            height: '100%',
                        }}>
                            {props.general && props.general()}
                        </Grid>
                    <Grid item style={{
                        margin: 0,
                        padding: 0,
                        width: 'calc(100% - 350px)',
                        minWidth: 'calc(100% - 350px)',
                        maxHeight: '100%',
                        height: '100%',
                        position: 'relative',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        borderLeft: '1px solid ' + EurestoColor('EurestoPrimary')
                    }}>
                        <Grid container spacing={0}
                            style={{
                                margin: 0,
                                padding: 0,
                                maxHeight: "100%",
                                height: '100%',
                                position: 'relative'
                            }}
                            justify='flex-start'>
                            <Grid item
                                style={{
                                    margin: 0,
                                    //padding: '0px 5px',
                                    maxHeight: "100%",
                                    height: '100%',
                                    position: 'relative'
                                }}
                                xs={12}>
                                <div id={'tab-information'} style={{
                                    maxHeight: "100%",
                                    height: '100%',
                                    overflow: 'auto',
                                    position: 'relative'
                                }}>
                                    {
                                        props.tabs.filter(tab => props.value === tab.value).map(tab => tab.component())
                                    }
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
            <Modal key={modalDelete} open={modalDelete} onClose={onCloseDeleteModal(false)}
                grid={{ xs: 3 }}>
                <EurestoDiv
                    paddingTopBody={0}
                    fromModal={true} style={{
                        margin: 0,
                        padding: 0,
                        overflowY: 'auto'
                    }} title={EurestoI18n.t('commun:Confirmation de suppression ') + `(${props.libelle})`}
                    buttonsLeft={[{
                        icon: ' ei-commun_fermer',
                        className: 'EurestoError--text EurestoText',
                        cb: onCloseDeleteModal(false)
                    }]}
                    buttonsRight={[{
                        icon: ' ei-commun_valider',
                        className: 'text-success',
                        cb: () => {
                            onCloseDeleteModal(false)
                            props.onDelete && props.onDelete()
                        }
                    }]}>
                    <Grid container style={{ margin: 0, padding: 10 }} spacing={0} justify={'flex-start'}
                        alignItems={'center'}>
                        <Grid item style={{ margin: 0, padding: 0 }}>
                            <span style={{
                                wordWrap: 'break-word',
                                width: '100%',
                                whiteSpace: 'initial',
                            }}>{EurestoI18n.t('commun:Êtes-vous sur de vouloir supprimer cet élément ? ') + `(${props.libelle})`}</span>
                        </Grid>
                    </Grid>
                </EurestoDiv>
            </Modal>
        </Grid>)

}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/MainForm/index.js